import { combineReducers } from 'redux';

import userLocation from '../reducers/SearchLocationReducer';
import searchService from '../reducers/SearchServiceReducer';
import searchField from '../reducers/SearchFieldReducer';
import services from '../reducers/ServicesReducer';
import routes from '../reducers/RoutesReducer';
import service from '../reducers/ServiceReducer';
import mobileScreen from '../reducers/MobileReducer';
import ticket from '../reducers/TicketReducer';
import rating from '../reducers/RatingReducer';
import popupReducer from '../reducers/PopupReducer';

const appReducer = combineReducers({
  userLocation,
  searchService,
  searchField,
  services,
  routes,
  service,
  mobileScreen,
  ticket,
  rating,
  popupReducer
});

export const rootReducer = (state, action) => {
  return appReducer(state, action)
};



// WEBPACK FOOTER //
// ./src/store/rootReducer.js